import {
  ButtonGroup,
  ButtonGroupSeparator,
  ButtonGroupText,
  buttonGroupVariants,
} from './components/ui/button-group.js';

// eslint-disable-next-line react-refresh/only-export-components
export { buttonGroupVariants };

export const DimeButtonGroup = ButtonGroup;
export const DimeButtonGroupSeparator = ButtonGroupSeparator;
export const DimeButtonGroupText = ButtonGroupText;
